import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actions';
import classes from './ClientInfo.css';
import NumberFormat from "react-number-format";

export class ClientInfo extends Component {

    convertZeroLead = (value) => {

        var v = parseInt(value);

        if (v < 10) {
            return "0" + v.toString();
        }

        return v.toString();

    };

    handleChangeRaw(value) {
        var parts = value.split("/");

        if (parts.length < 3) return;

        var month = this.convertZeroLead(parts[0]);
        var day = this.convertZeroLead(parts[1]);


        if (parseInt(parts[2]) > 1800) {
            var year = this.convertZeroLead(parts[2]);
            var result =  year + "-" + month + "-" + day;
            const myDate = moment(result, 'YYYY-MM-DD');
            this.props.updateClientInfo("dateOfBirth", myDate);
        }

    }

    render() {

        let firstNameClass = [classes.firstName];
        let lastNameClass = [classes.lastName];
        let stateClass = [];

        if (this.props.firstNameInvalid) {
            firstNameClass.push(classes.invalid);
        }

        if (this.props.lastNameInvalid) {
            lastNameClass.push(classes.invalid);
        }

        if (this.props.stateInvalid) {
            stateClass.push(classes.invalid);
        }

        let nameFields;
        let birthdayAgeField;
        if(this.props.companyName === "WELLS_FARGO") {
            this.props.updateClientInfo("firstName", "Sample");
            this.props.updateClientInfo("lastName", "Client");

            birthdayAgeField = (
                <div className={classes.clientBirthDate}>
                    <label>
                        Age:
                    </label>
                    <NumberFormat
                        value={this.props.age}
                        onChange={(event) => this.props.updateClientInfo("age", event.target.value)}
                        onClick={() => this.props.updateClientInfo("age", "CLICK")}
                        onBlur={() => this.props.updateClientInfo("age", "BLUR")}
                        displayType={'input'}
                        decimalScale={0}
                        thousandSeparator={false}
                    />
                </div>
            );
        }else {
            nameFields = (
                <div className={classes.clientName}>
                    <label>Client Name:</label>
                    <input
                        className={firstNameClass.join(' ')}
                        placeholder="First Name"
                        value={this.props.firstName}
                        onChange={(event) => {this.props.updateClientInfo("firstName", event.target.value)}}
                    />
                    <input
                        className={lastNameClass.join(' ')}
                        value={this.props.lastName}
                        onChange={(event) => {this.props.updateClientInfo("lastName", event.target.value)}}
                        placeholder="Last Name"
                    />
                </div>
            );

            birthdayAgeField = (
                <div className={classes.clientBirthDate}>
                    <label>
                        Date of Birth:
                        <br/><span className={classes.smallText}>( MM/DD/YYYY )</span>
                    </label>
                    <DatePicker
                        selected={this.props.dateOfBirth}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={moment().subtract(1, "days")}
                        onChange={(date) => {this.props.updateClientInfo("dateOfBirth", date)}}
                        onChangeRaw={(event) =>
                            this.handleChangeRaw(event.target.value)}
                        placeholderText="MM/DD/YYYY"
                    />
                </div>
            );
        }

        return (
            <div className={classes.ClientInfo}>
                <span className={classes.requiredFieldsMsg}>* All fields are required</span>
                <span className={classes.requiredFieldsMsg}>Enter the following information for the existing portfolio</span>
                {nameFields}
                {birthdayAgeField}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        firstName: state.planInfo.clientInfo.firstName.value,
        lastName: state.planInfo.clientInfo.lastName.value,
        dateOfBirth: state.planInfo.clientInfo.dateOfBirth.value,
        age: state.planInfo.clientInfo.age.value,
        state: state.planInfo.clientInfo.state.value,
        firstNameInvalid: state.planInfo.clientInfo.firstName.invalid,
        lastNameInvalid: state.planInfo.clientInfo.lastName.invalid,
        stateInvalid: state.planInfo.clientInfo.state.invalid,
        companyName: state.globalState.companyName
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateClientInfo: (key, value) => dispatch({type: actionTypes.CLIENTINFO_UPDATE, data:{
            key: key,
            value: value
        }})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientInfo);


// WEBPACK FOOTER //
// ./src/containers/ClientInfo/ClientInfo.js